export default __webpack_public_path__ + "static/media/icon-clock-grey.6486b992.svg";